import { LOAD_LAYOUT, UPDATE_LAYOUT } from './constants'

const initialState = {
  layout: ['bulletin', 'recent', 'favourites', 'launch']
}

const stripDisabled = (layout) => layout.filter(item => item !== 'trending')

export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_LAYOUT:
    case UPDATE_LAYOUT: {
      return {
        ...state,
        layout: stripDisabled(action.layout)
      }
    }
    default: {
      return state
    }
  }
}
